import {component} from '../form/Constant'

export const generalPractitionerKey = {
    gpId: 'gpId',
    name: 'name',
    surgery: 'surgery',
    email: 'email',
    address: 'address',
}
export const generalPractitionerList = [
    {
        key: 'information',
        description: 'Fill in the GP’s information details.',
        required: true,
        children: [
            {
                key: generalPractitionerKey.name,
                required: true,
                component: component.inputText,
                placeholder:
                    "Input general practitioner's name - Field is required",
            },
            {
                key: generalPractitionerKey.email,
                component: component.inputText,
                required: true,
                keyFilter: true,
                placeholder:
                    "Input general practitioner's email - Field is required",
            },
            {
                key: generalPractitionerKey.surgery,
                component: component.inputText,
                placeholder: 'Input description',
            },
        ],
    },
    {
        key: 'contactInformation',
        description: 'Fill in the GP’s contact details.',
        children: [
            {
                key: generalPractitionerKey.address,
                hideHeader: true,
                component: component.address,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
]
